import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34;
const START_TIME = Date.now();

function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - START_TIME) / 1000);
  return DURATION_SECONDS - (elapsed % DURATION_SECONDS);
}

export function useLoopCountdown() {
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  return { hours, minutes, seconds };
}
